import React, { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Spinner from "../../sample/spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt, faEnvelope } from "@fortawesome/free-solid-svg-icons";
//import { Link } from "react-router-dom";
import MaterialTable from "material-table";
import { Row, Col } from "reactstrap";
import { UserContext } from "../../../context/UserContext";
import { Redirect } from "react-router";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import MaterialComponent from "../LearnerAssesment/MaterialComponent";
const Helpdesk = () => {
  const context = useContext(UserContext);

  const [prevqcat, setPrevqcat] = useState([]);
  const [prevqt, setPrevqt] = useState([]);
  const [prevfirstname, setPrevfirstname] = useState("");
  const [prevlastname, setPrevlastname] = useState("");
  const [prevemail, setPrevemail] = useState("");
  const [myquerylist, setMyquerylist] = useState([]);

  const [mobileno, setMobileno] = useState("");
  const [decription, setDecription] = useState("");
  //const [email, setEmail] = useState("");
  const [category, setCategory] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIodalIsOpen] = useState(false);
  const [filepath, setFilepath] = useState(null);
  useEffect(() => {
    // Update the document title using the browser API
    getprofile();
  }, []);
  const getprofile = async () => {
    axios
      .post("HelpDesk/lhelpdesk")
      .then((res) => {
        if (res.data.status === "200") {
          setPrevfirstname(res.data.firstName);
          setPrevlastname(res.data.lastName);
          setPrevemail(res.data.email);
          setMobileno(res.data.contactnumber);
          setPrevqt(res.data.qt);
          setPrevqcat(res.data.qcat);
          setMyquerylist(res.data.myquerylist);
        
          //  console.log("mobileno =="+ mobileno);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  const handlerSubmit = (e) => {
    e.preventDefault();
    senddetails();
  };

  const senddetails = async () => {
    setLoading(true);
    if (selectedFile) {
      let filename = selectedFile.name.split(".").pop();
      // console.log("filename  ---"  + filename)
      if (
        filename !== "pdf" &&
        filename !== "doc" &&
        filename !== "docx" &&
        filename !== "jpg" &&
        filename !== "png" &&
        filename !== "jpeg"
      ) {
        toast.error(" upload only pdf/doc/docx/jpg/png/jpeg  files");
        await sleep(3000);
        setLoading(false);
        return;
      }
    }

    if ((mobileno && mobileno.length < 6) || mobileno.length > 12) {
      toast.error(
        "Please enter valid Phone no , without prefix. eg- 9784984899"
      );
      await sleep(3000);
      setLoading(false);
      return;
    } else if (category === "" || category === null) {
      toast.error(" Category is mandatory  ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if ((decription === "") | (decription === null)) {
      toast.error("  Decription  is mandatory  ");
      await sleep(3000);
      setLoading(false);
      return;
    } else {
      var formData = new FormData();
   
      formData.append("contact", mobileno);
      formData.append("qtype", category);
      formData.append("desc", decription);
      formData.append("fname", prevfirstname);
      formData.append("mail", prevemail);

      formData.append("lname", prevlastname);
      formData.append("attach", selectedFile);

      await axios
        .post("HelpDesk/saveQuery", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.message);
            //setMysavequerylist(res.data.mysavequerylist)
            setMyquerylist(res.data.mysavequerylist);
            // setIsLoading(false)
          
            setLoading(false);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };
  if (!context.user?.email) {
    return <Redirect to="/" />;
  }

  const openModal = (e, file) => {
    // console.log("id =" + file);
    setIodalIsOpen(true);
    setFilepath(file);
    // updateskills(id);
  };

  const closeModal = (e, pdfpath) => {
    setIodalIsOpen(false);
  };
  return (
    <div>
      <section class="padding-default2">
        <div class="row ">
          <div class="col-md-6">
            <div class="panel panel-primary card">
              <div class="panel-heading">Help Desk </div>

              <div class="panel-body">
                <form>
                  <div class="row ">
                    <div class="col-md-10">
                      <div class="form-group">
                        <span class="input">
                          <label class="input_label">
                            <b>Category</b>
                          </label>
                          <select
                            class="form-control"
                            required
                            name="category"
                            onChange={(e) => setCategory(e.target.value)}
                            id="skillcategory"
                          >
                            <option value="null">Select Category</option>
                            {prevqt.map((item) => (
                              <option value={item.name}>{item.name}</option>
                            ))}
                          </select>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="row ">
                    <div class="col-md-10">
                      <div class="form-group">
                        <span class="input">
                          <label class="input_label">
                            <b> First Name </b>
                          </label>
                          <input
                            class="form-control"
                            type="text"
                            value={prevfirstname}
                            id="name"
                            name="name"
                            onChange={(e) => setPrevfirstname(e.target.value)}
                            readOnly
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-md-10">
                      <div class="form-group">
                        <span class="input">
                          <label class="input_label">
                            <b>Last Name </b>
                          </label>
                          <input
                            placeholder="provide your Name"
                            class="form-control"
                            type="text"
                            value={prevlastname}
                            id="name"
                            name="name"
                            onChange={(e) => setPrevlastname(e.target.value)}
                            readOnly
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-md-10">
                      <div class="form-group">
                        <span class="input">
                          <label class="input_label">
                            <b> Email Address</b>
                          </label>
                          <input
                           
                            class="form-control"
                            type="text"
                            value={prevemail}
                            id="name"
                            name="name"
                            onChange={(e) => setPrevemail(e.target.value)}
                            readOnly
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-md-10">
                      <div class="form-group">
                        <span class="input">
                          <label class="input_label">
                            <b> Contact </b>
                          </label>

                          <input
                            required
                            type="text"
                            name="mobileno"
                            class="form-control"
                            value={mobileno}
                            id="mobileno"
                            onChange={(e) => setMobileno(e.target.value)}
                            placeholder="Enter Mobile No"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-md-10">
                      <div class="form-group">
                        <span class="input">
                          <label class="input_label">
                            <b> Description </b>
                          </label>
                          <textarea
                            class="form-control"
                            name="decription"
                            placeholder="Tell others what you think about this course."
                            id="decription"
                            // value={this.state.decription}
                            onChange={(e) => setDecription(e.target.value)}
                            rows={4}
                            cols={100}
                            required=""
                          ></textarea>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-md-10">
                      <div class="form-group">
                        <span class="input">
                          <label class="input_label">
                            <b> Attachment </b>
                          </label>
                          <input
                            class="form-control"
                            id="cvfile"
                            type="file"
                            name="cvfile"
                            onChange={(e) => setSelectedFile(e.target.files[0])}
                          />
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="root">
                    <div className="wrapper">
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={loading}
                        onClick={(e) => handlerSubmit(e)}
                      >
                        Send
                      </Button>

                      {loading === true ? (
                        <CircularProgress
                          size={24}
                          color="green"
                          className="buttonProgress1"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="panel panel-primary card">
              <div class="panel-heading">Career Guidance </div>
              <div class="panel-body">
                <h5>
                  {" "}
                  <b>For any career Guidance Contact Us </b>
                </h5>
                <br />
                <h6>
                  <b>
                    <FontAwesomeIcon icon={faPhoneAlt} />
                  </b>
                  <span style={{ fontweight: "normal", paddingleft: "4px" }}>
                    <a href="tel://8956167195">+91 89561 67195</a> /
                    <a href="tel://8956167196"> +91 89561 67196 </a>
                  </span>
                </h6>
                <br />
                <h6>
                  <b>
                    {" "}
                    <FontAwesomeIcon icon={faPhoneAlt} />
                  </b>{" "}
                  <span style={{ fontweight: "normal", paddingleft: "4px" }}>
                    <a href="tel://8956167197"> +91 89561 67197</a> /
                    <a href="tel://8956167198"> +91 89561 67198</a>{" "}
                  </span>
                </h6>
                <br />
                <h6>
                  <b>
                    {" "}
                    <FontAwesomeIcon icon={faEnvelope} />
                  </b>
                  <span style={{ fontweight: "normal", paddingleft: "4px" }} />
                  support@eduplusnow.com{" "}
                </h6>
                <br />
              </div>
            </div>
          </div>
        </div>
      </section>
      {isLoading ? <Spinner /> : ""}
      <section class=" padding-default">
        <div class="panel panel-primary card">
          <div class="panel-heading">My Queries</div>
          <div class="panel-body">
            <Row>
              <Col xs="12" sm="12" md="12">
                <span>
                  <MaterialTable
                    title="My Queries"
                    columns={[
                      { title: "Sr.No.", field: "srno" },
                      { title: "First Name", field: "firstName" },
                      { title: "last Name", field: "lastName" },
                      { title: "Contact No. ", field: "mobileno" },
                      { title: "Query Category", field: "querycategory" },
                      { title: "Query Type", field: "querytype" },
                      { title: "Description", field: "description" },
                      { title: "Query Status", field: "querystatus" },                 
                   
                    ]}
                    data={myquerylist}
                    actions={[
                      (rowData) => {
                        return rowData.viewfilepath
                          ? {
                              icon: () => <GetAppIcon color={"primary"} />,

                              tooltip: "download attachment",
                              onClick: (event, rowData) =>
                                openModal(event, rowData.viewfilepath),
                            }
                          : {
                              icon: () => <GetAppIcon color={"disabled"} />,
                              disable: true,
                              tooltip: "no attachment",
                            };
                      },
                    ]}
                    options={{
                      exportButton: true,
                      actionsColumnIndex: -1,
                    }}
                  />
                </span>
              </Col>
            </Row>
          </div>
        </div>
      </section>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        size="md"
        // style={{height:"10px"}}
        style={{
          top: "1%",
          bottom: "70%",
          height: "60px",
        }}
      >
        <ModalHeader toggle={closeModal} className="header-modalc">
          {" "}
          Attachment {" "}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col xs="10" sm="12" md="12">
              {filepath ? (
                <>
                  <MaterialComponent
                    contentType="contenttype"
                    contentId="0"
                    materialid="0"
                    materialtype={filepath.split(".").pop()}
                    materialpath={filepath}
                  />
                </>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <br /> <br />
    </div>
  );
};

export default Helpdesk;
